import { createElement } from "/elements_functions/new_elements.js";
import {logOut} from '/login/logout.js';
import { makeNewButton } from '/buttons_functions/custom_button_functions.js';
import {API_GATEWAY, SITE_URL} from '/constants/API_constants.js';

const LEFT_SIDE_LABEL_COLOR = 'rgb(235, 235, 235)';

export function createLeftSideContent(loginToken, profile_pic, username, name) {
    const elementsList = [];

    //---------------My Profile-------------------------
    const avatarAndProfile = createElement('a', 'left-side-content-my-profile', ['left-side-content-row']);
    const avatar = createElement('img', null, null);
    avatar.src = '/images/icons/profile.png';
    const myProfileLabel = createElement('p', null, null);
    myProfileLabel.innerText = 'Log In';

    avatarAndProfile.append(avatar, myProfileLabel);

    makeNewButton(avatarAndProfile, LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    
    if(loginToken!==null) {
        myProfileLabel.innerText = 'My Profile';
        if(username!==null && username!==undefined) {
            avatarAndProfile.href = SITE_URL+'/user/page/'+username;
            myProfileLabel.innerText = '@'+username;
        }
        if(name!==null && name!==undefined) {
            myProfileLabel.innerText = name;
        }
        
        if(profile_pic!==null) {
            avatar.src=profile_pic;
        }
    } else {
        avatarAndProfile.href = '/login';
    }

    elementsList.push(avatarAndProfile);

    const siteContent = createElement('div', null, ['left-side-content-section']);
    
    //---------------feed-------------------------
    const feed = createElement('a', 'left-side-contnet-feed', ['left-side-content-row']);
    const feedPic = createElement('img', null, null);
    feedPic.src = '/images/icons/feed.png';
    const feedLabel = createElement('p', null, null);
    feedLabel.innerText = 'Feed';

    feed.append(feedPic, feedLabel);

    makeNewButton(feed, LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    feed.href = '/feed';

    //---------------messages-------------------------
    const messages = createElement('a', 'left-side-contnet-messages', ['left-side-content-row']);
    const messagesPic = createElement('img', null, null);
    messagesPic.src = '/images/icons/messages.png';
    const messagesLabel = createElement('p', null, null);
    messagesLabel.innerText = 'Messages';

    messages.append(messagesPic, messagesLabel);

    makeNewButton(messages, LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    messages.href = '/will-appear-soon';

    //---------------About-------------------------
    const aboutTheProject = createElement('a', 'left-side-contnet-about', ['left-side-content-row']);
    const aboutTheProjectPic = createElement('img', null, null);
    aboutTheProjectPic.src = '/images/icons/about_the_project.png';
    const aboutTheProjectLabel = createElement('p', null, null);
    aboutTheProjectLabel.innerText = 'About The Project';

    aboutTheProject.append(aboutTheProjectPic, aboutTheProjectLabel);

    makeNewButton(aboutTheProject, LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    aboutTheProject.href = '/about/the-project';

    //---------------Partners-------------------------
    const partners = createElement('a', 'left-side-contnet-partners', ['left-side-content-row']);
    const partnersPic = createElement('img', null, null);
    partnersPic.src = '/images/icons/handshake.png';
    const partnersLabel = createElement('p', null, null);
    partnersLabel.innerText = 'Our partners';

    partners.append(partnersPic, partnersLabel);

    makeNewButton(partners, LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    partners.href = '/about/our-partners';

    siteContent.append(feed, messages, aboutTheProject, partners);
    elementsList.push(siteContent);

    
    //---------------Log Out-------------------------
    if(loginToken!=null) {
        const logOutRow = createElement('div', 'left-side-contnet-logout', ['left-side-content-row']);
        const logoutPic = createElement('img', null, null);
        logoutPic.src = '/images/icons/log_out.png';
        const logoutLabel = createElement('p', null, null);
        logoutLabel.innerText = 'Log out';
    
        logOutRow.append(logoutPic, logoutLabel);
    
        makeNewButton(logOutRow, LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
        logOutRow.addEventListener('click', ()=> logOut());

        elementsList.push(logOutRow);
    }
    
    return elementsList;
}

function goToLink(link) {
    window.location=link;
}